<template>
    <div class="policy-box">
        <div class="head">
            <span class="head-title">工业产业投资政策要点</span>
        </div>
        <v-touch v-on:tap="tap" class="wrapper">
            <div class="wuqun" v-for="item in ditel" :key="item.id">
                <router-link :to="{ path: 'poldtl', query: { id: item.id } }">
                    <div class="zhengti">
                        <img
                            :src="`${domianURL}/${item.icoOne}`"
                            alt=""
                            class="icon"
                        />
                        <span class="chans">{{ item.name }}</span>
                    </div>
                </router-link>
            </div>
        </v-touch>
        <img src="@/assets/image/policy/bg.png" alt="" class="pobg" />
    </div>
</template>

<script>
import { getAction } from "@/api/manage.js";
export default {
    created() {
        this.loadData();
    },
    data() {
        return {
            ditel: {},
        };
    },
    methods: {
        tap: function () {
            console.log("点击事件");
        },
        loadData() {
            getAction("/sys/category/loadTreeByCode", {
                pid: "1356812611114549249",
            }).then((res) => {
                if (res.success) {
                    this.ditel = res.result;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.policy-box {
    .head {
        -webkit-animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
        animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
        width: 88%;
        height: 10%;
        background-color: #dca74e;
        border-radius: 18px;
        margin: 83px auto 0;
        text-align: center;
        .head-title {
            font-size: 1.3rem;
            font-weight: bold;
            font-stretch: normal;
            line-height: 50px;
            letter-spacing: 1px;
            color: #ffffff;
        }
    }
    .pobg {
        position: fixed;
        width: 100%;
        bottom: 0;
        z-index: -1;
    }
    .wrapper {
      -webkit-animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
      animation: fade-in-top 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    }
    .zhengti {
        position: relative;
        &:before {
            border-left: 1px solid #dca74e;
            content: " ";
            height: 42px;
            position: absolute;
            top: -105%;
            left: 45%;
            z-index: -1;
        }
        &:after {
            border: 1px solid #dca74e;
            content: " ";
            width: 98%;
            height: 99%;
            position: absolute;
            left: 5%;
            top: 29%;
            z-index: -1;
        }
        &:active {
            background-color: #dca84ea2;
            border: solid 1px #dca74e;
            color: #ffffff;
        }
        width: 66%;
        height: 8%;
        background-color: #ece9e3;
        border: solid 1px #dca74e;
        margin-top: 32px;
        margin-left: 56px;
        .icon {
            width: 8%;
            margin-top: 10px;
            margin-left: 23px;
        }
        .chans {
            font-size: 17px;
            font-weight: bold;
            letter-spacing: 1px;
            position: relative;
            left: 16px;
            top: -5px;
            color: #333333;
        }
    }
}
.ie {
    z-index: -1;
}
</style>